// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const EmailInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 11"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="11"
            fill="currentColor"
        >
            <path
                d="M512,630.375 C511.548008,630.375 511.096016,630.226742 510.710469,629.926289 L505,625.485938 L505,631.6875 C505,632.412109 505.587617,633 506.3125,633 L517.6875,633 C518.412383,633 519,632.412383 519,631.6875 L519,625.485938 L513.290625,629.929297 C512.905078,630.227344 512.451172,630.375 512,630.375 Z M505.44543,624.723047 L511.247773,629.237501 C511.690469,629.582032 512.310625,629.582032 512.75332,629.237501 L518.555664,624.723047 C518.811328,624.504297 519,624.167969 519,623.8125 C519,623.087617 518.412109,622.5 517.6875,622.5 L506.3125,622.5 C505.587617,622.5 505,623.087617 505,623.8125 C505,624.167969 505.164336,624.504297 505.44543,624.723047 L505.44543,624.723047 Z"
                opacity=".66"
                transform="translate(-505 -622)"
            />
        </svg>
    );
};

export default React.memo(EmailInactive);
